import { useKeycloak } from '@react-keycloak/web';
import React, { useEffect, useState } from 'react';
import { Switch, HashRouter } from 'react-router-dom';

import { PrivateRoute } from './utils/PrivateRouteOnline';
import { PrivateRouteOffline } from './utils/PrivateRouteOffline';
import { TheLayout } from './containers';
import Loading from './components/Loading/Loading';
import { OfflineAuthProvider } from './context/offlineAuth';
import { AuthProvider } from './context/auth';
import { GlobalProvider } from './data/GlobalProvider';
import { REACT_APP_SCANNER_OFFLINE } from './data/data';

const OfflineRouter = () => (
    <GlobalProvider>
        <OfflineAuthProvider>
            <HashRouter>
                <React.Suspense fallback={<div>Carregando...</div>}>
                    <Switch>
                        <PrivateRouteOffline
                            path="/"
                            name="Home"
                            component={props => <TheLayout {...props} />}
                        />
                    </Switch>
                </React.Suspense>
            </HashRouter>
        </OfflineAuthProvider>
    </GlobalProvider>
);

const OnlineRouter = () => {
    const { keycloak, initialized } = useKeycloak();
    const [userInfo, setUserInfo] = useState();

    useEffect(() => {
        if (initialized && keycloak.authenticated) {
            keycloak.loadUserProfile().then(profile => {
                const token = keycloak.idTokenParsed || {};

                setUserInfo({
                    username: profile.username,
                    clientID: token.clientIDAttr || 'N/A',
                    userID: token.userIDAttr || 'N/A',
                });
            });
        }
    }, [initialized, keycloak]);

    if (!initialized) {
        return <Loading />;
    }

    if (!keycloak.authenticated) {
        keycloak.login();
        return <div>Redirecionando para login...</div>;
    }

    return (
        <GlobalProvider>
            <AuthProvider>
                <HashRouter>
                    <React.Suspense fallback={<div>Carregando...</div>}>
                        <Switch>
                            <PrivateRoute
                                roles={['default-roles-alpha manager']}
                                path="/"
                                name="Home"
                                component={props => <TheLayout {...props} />}
                            />
                        </Switch>
                    </React.Suspense>
                </HashRouter>
            </AuthProvider>
        </GlobalProvider>
    );
};

const AppRouter = () => {
    return REACT_APP_SCANNER_OFFLINE
        ? <OfflineRouter />
        : <OnlineRouter />;
};

export default AppRouter;